module.exports = __webpack_public_path__ + "static/media/vsign.944bbea4.png";